import { render, staticRenderFns } from "./QbTr.vue?vue&type=template&id=23807fbb"
import script from "./QbTr.vue?vue&type=script&lang=js"
export * from "./QbTr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports